import {useTrackContentView} from '@aboutyou/tracking';
import {useEffect} from 'react';
import {WalletType, useActiveTab} from './useActiveTab';
import {useWalletStateManager} from './useWalletStateManager';

const trackedContentViews = new Set<WalletType>();

export const useTrackWalletContentView = () => {
  const trackContentView = useTrackContentView();
  const {isOpen} = useWalletStateManager();
  const {activeTab} = useActiveTab();

  useEffect(() => {
    // The content_view event should fire only once, even when switching between tabs, to avoid tracking noise.
    if (!isOpen || trackedContentViews.has(activeTab)) {
      return;
    }

    trackedContentViews.add(activeTab);
    const page = (() => {
      switch (activeTab) {
        case 'coins':
          return 'coins_wallet';
        case 'coupons':
          return 'coupon_wallet';
        case 'notificationCenter':
          return 'notification_center';
        default:
          return '';
      }
    })();

    trackContentView({
      pageTitle: page,
      overridePageProps: {type: page},
    });
    // Only the active tab should trigger the event
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);
};
